import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPrioritiesEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-priorities-edit',
	path: '/secure/admin/EditPriority!default.jspa',
};
